<template>
  <div class="linkedin-company">
    <table>
      <thead>
        <th>Key</th>
        <th>Value</th>
      </thead>
      <tbody>
        <tr v-for="(ele, index) in keys" :key="index">
          <td>{{ ele }}</td>
          <td>{{ stateData[ele] || 'N/A' }}</td>
        </tr>
      </tbody>
    </table>
    <div class="input-label-wrap" v-if="!loading">
      <label for="linkedinUrl">
        Linkedin URL
      </label>
      <input
        v-model="stateData.liUrl"
        placeholder="Linkedin URL"
        id="linkedinUrl"
        autocomplete="off"
        required="true"
        type="text"
      />
    </div>
    <div class="input-label-wrap" v-if="!loading">
      <label for="website">
        Displayed Website
      </label>
      <input
        v-model="stateData.displayedWebsite"
        placeholder="Website"
        id="website"
        autocomplete="off"
        required="true"
        type="text"
        readonly="true"
      />
    </div>
    <div class="input-label-wrap" v-if="!loading">
      <label for="redirectedWebsite">
        Redirected Website
      </label>
      <input
        v-model="stateData.redirectedWebsite"
        placeholder="Redirected Website"
        id="redirectedWebsite"
        autocomplete="off"
        required="true"
        type="text"
      />
    </div>
    <V-Button
      :className="'sync btn-blue'"
      :text="'Save Company'"
      :loading="loading"
      :callback="syncCompanyData"
      :disableBtn="Object.keys(stateData || {}).length === 0"
    ></V-Button>
    <div v-if="toast" class="toast">
      <div>{{ toastText }}</div>
      <i class="material-icons closePopup" @click="closeToast">close</i>
    </div>
    <div v-if="error.show" class="error">
      <div>Following keys are missing:</div>
      <div>{{ error.missingKeys.toString() }}</div>
      <V-Button
        :className="'proceed'"
        :text="'Proceed'"
        :loading="loading"
        :callback="syncCompanyData"
      ></V-Button>
      <i class="material-icons closePopup" @click="closePopup">close</i>
    </div>
    <div class="backdrop" v-if="error.show"></div>
    <div class="backdrop" v-if="loading">
      <Spinner />
    </div>
  </div>
</template>

<script>
import button from '@/components/Button'
import Spinner from '@/components/Spinner'
import { HttpUrl } from '../assets/util/constants/analytics'
import { post } from '../assets/util/rest'

const keys = [
  'name',
  'industry',
  'location',
  'displayedWebsite',
  'about',
  'founded',
  'companyType',
  'employeeCount',
  'cLevelCount',
  'liUrl',
  'salesNavUrl',
  'redirectedWebsite'
]

export default {
  name: 'LinkedinCompany',
  props: ['companyData'],
  data: function() {
    return {
      stateData: {},
      keys: keys,
      error: {
        show: false,
        missingKeys: []
      },
      toast: false,
      toastText: '',
      loading: false
    }
  },
  watch: {
    companyData: {
      handler(newValue, oldValue) {
        if (!oldValue || oldValue.salesNavUrl !== newValue.salesNavUrl) {
          const { website, ...rem } = newValue
          this.stateData = {
            displayedWebsite: website,
            redirectedWebsite: website,
            ...rem
          }
        }
      }
    }
  },
  components: {
    'V-Button': button,
    Spinner: Spinner
  },
  methods: {
    closePopup() {
      this.error = {
        show: false,
        missingKeys: []
      }
    },
    closeToast() {
      this.toast = false
      this.toastText = ''
    },
    syncCompanyData() {
      const fromPopup = this.error.show
      this.error = {
        show: false,
        missingKeys: []
      }
      const requestData = {
        url: this.stateData.salesNavUrl,
        data: this.stateData
      }
      const missingKeys = []
      keys.forEach(key => {
        const dataAvl = !!this.stateData[key]
        if (!dataAvl) {
          missingKeys.push(key)
        }
      })

      if (missingKeys.length > 0 && !fromPopup) {
        this.error = {
          show: true,
          missingKeys: missingKeys
        }
      } else {
        this.loading = true
        post(HttpUrl.updateSNCompanyData, requestData).then(response => {
          if (response.status === 200) {
            this.toastText = 'Company data synced successfully'
          } else {
            this.toastText = 'Failed'
          }
          this.toast = true
          this.loading = false
        })
      }
      setTimeout(() => {
        // this.closePopup()
        this.toast = false
      }, 5000)
    }
  }
}
</script>

<style scoped lang="scss">
.linkedin-company {
  padding: 8px;
  overflow: hidden;
  table {
    border: 1px solid #ccc;
    border-collapse: collapse;
    width: 100%;
    table-layout: fixed;
    margin-bottom: 8px;

    td,
    th {
      border: 1px solid #ccc;
      padding: 4px;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  }
  :global(.sync) {
    width: 100%;
    margin: 8px 0;
    padding: 8px;
  }

  :global(.sync:disabled) {
    opacity: 0.5;
  }

  .input-label-wrap {
    display: flex;
    flex-direction: column;

    label {
      font-size: 13px;
      line-height: 20px;
      color: $grey-text;
      margin-bottom: 5px;
    }

    input {
      outline: 0;
      background: #ffffff;
      border: 1px solid rgba(102, 112, 128, 0.2);
      box-shadow: none;
      border-radius: 6px;
      padding: 7px 16px;
      font-size: 14px;
      line-height: 22px;
      color: $grey-text;

      &[readonly] {
        cursor: not-allowed;
      }

      &:focus,
      &:focus-visible {
        border: 1px solid $primary-color;
      }
    }
  }

  .toast {
    z-index: 999;
    position: fixed;
    top: 80px;
    left: 50%;
    width: 250px;
    transform: translateX(-50%);
    color: #fff;
    background: gray;
    border-radius: 4px;
    padding: 4px 8px;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .error {
    z-index: 999;
    position: fixed;
    background: white;
    box-shadow: 0 0 1px 0px rgba(0, 0, 0, 0.16);
    padding: 16px;
    top: 50%;
    left: 50%;
    width: 250px;
    border-radius: 8px;
    transform: translate(-50%, -50%);
    word-wrap: break-word;
    display: flex;
    flex-direction: column;
    gap: 8px;
    .closePopup {
      top: 10px;
      transform: none;
      color: initial;
    }
    + .backdrop {
      background: rgba(0, 0, 0, 0.3);
      z-index: 998;
      pointer-events: none;
      position: fixed;
      inset: 0;
    }
  }
  :global(.proceed) {
    margin-top: 4px;
    padding: 8px;
    display: flex;
  }
  .closePopup {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    color: #fff;
    font-size: 14px;
    &:hover {
      background: transparent;
    }
  }
  :global(.spinner) {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(2);
    z-index: 1000;
    pointer-events: none;
  }
}
</style>
